
import { defineComponent, ref } from 'vue';
import useConfig from '@/composables/useConfig';
import useTrainer from '@/composables/useTrainer';

import VNodeRenderer from '@/components/VNodeRenderer';

export default defineComponent({
	
	components: {
		VNodeRenderer
	},

	setup() {

		const config = useConfig()
		const { trainer } = useTrainer()

		const predict_x = ref({});
		const predict_y = ref({});
		
		return {
			config,
			trainer,

			predict_x,
			predict_y
		}

	}

});
